import { Create, SimpleForm } from 'react-admin';
import WebsiteListingFields from './WebsiteListingFields';
import { hasFixedSize } from './websiteApi';
import { withSlugFromName } from './formHelpers';

// A fixed size belongs only to Simple Tefillin, Mezuzah and Megillah; drop a leftover value
// if the family was switched while filling the form (the server rejects it otherwise).
const transform = data => withSlugFromName({
  ...data,
  fixed_selections: hasFixedSize(data.family) ? { size: data.fixed_selections?.size } : {},
  script_code: data.family === 'other' || data.family === 'price_on_request' ? null : data.script_code,
  category_ids: (data.extra_category_ids ?? []).filter(id => id !== data.category_id),
  extra_category_ids: undefined,
});

// After creating, the listing opens for prices, CRM mapping and publication.
const WebsiteProductCreate = () => (
  <Create title="מוצר אתר חדש" redirect="edit" transform={transform}>
    <SimpleForm defaultValues={{ availability: 'available', sort_position: 0, extra_category_ids: [] }}>
      <WebsiteListingFields isCreate />
    </SimpleForm>
  </Create>
);
export default WebsiteProductCreate;
